module.exports = __webpack_public_path__ + "media/bgvideo.02cc8c2e.mp4";